import {SportType} from "./sport-type";

export class SportTypeFieldsVisibility {
  maxParticipants: boolean | 0;
  startEvery: boolean | 0;
  maxParticipantsInStartBlock: boolean | 0;
  refreshmentCheckpointAmount: boolean | 0;
  length: boolean | 0;
  ascent: boolean | 0;
  descent: boolean | 0;
  maxAltitude: boolean | 0;
  minAltitude: boolean | 0;

  constructor(
    maxParticipants: boolean | 0,
    startEvery: boolean | 0,
    maxParticipantsInStartBlock: boolean | 0,
    refreshmentCheckpointAmount: boolean | 0,
    length: boolean | 0,
    ascent: boolean | 0,
    descent: boolean | 0,
    maxAltitude: boolean | 0,
    minAltitude: boolean | 0
  ) {
    this.maxParticipants = maxParticipants;
    this.startEvery = startEvery;
    this.maxParticipantsInStartBlock = maxParticipantsInStartBlock;
    this.refreshmentCheckpointAmount = refreshmentCheckpointAmount;
    this.length = length;
    this.ascent = ascent;
    this.descent = descent;
    this.maxAltitude = maxAltitude;
    this.minAltitude = minAltitude;
  }
}


export const sportsTypeVisibilityMap: Record<SportType, SportTypeFieldsVisibility> = {
  [SportType.ADVENTURE_RACING]: new SportTypeFieldsVisibility(true, true, true, true, true, true, true, true, true),
  [SportType.AQUATHLON]: new SportTypeFieldsVisibility(true, true, true,  true, true, 0, 0, 0, 0),
  [SportType.BACKYARD_ULTRA]: new SportTypeFieldsVisibility(true, 0, 0,  true, true, true, true, true, true),
  [SportType.BASKETBALL]: new SportTypeFieldsVisibility(true, false, false,  false, false, false, false, false, false),
  [SportType.BEER_MILE]: new SportTypeFieldsVisibility(true, true, true,  true, true, true, true, true, true),
  [SportType.CANICROSS]: new SportTypeFieldsVisibility(true, true, true,  true, true, true, true, true, true),
  [SportType.CROSS_COUNTRY_SKIING]: new SportTypeFieldsVisibility(true, true, true,  true, true, true, true, true, true),
  [SportType.CROSS_RUNNING]: new SportTypeFieldsVisibility(true, true, true,  true, true, true, true, true, true),
  [SportType.CROSSFIT]: new SportTypeFieldsVisibility(true, true, true,  true, false, false, false, false, false),
  [SportType.CYCLING_CYCLOCROSS]: new SportTypeFieldsVisibility(true, true, true,  true, true, true, true, true, true),
  [SportType.CYCLING_ENDURO]: new SportTypeFieldsVisibility(true, true, true,  true, true, true, true, true, true),
  [SportType.CYCLING_GRAVEL]: new SportTypeFieldsVisibility(true, true, true,  true, true, true, true, true, true),
  [SportType.CYCLING_MOUNTAINBIKE]: new SportTypeFieldsVisibility(true, true, true,  true, true, true, true, true, true),
  [SportType.CYCLING_PUMPTRACK]: new SportTypeFieldsVisibility(true, true, true,  true, true, true, true, true, true),
  [SportType.CYCLING_ROAD]: new SportTypeFieldsVisibility(true, true, true,  true, true, true, true, true, true),
  [SportType.DUATHLON]: new SportTypeFieldsVisibility(true, true, true,  true, true, true, true, true, true),
  [SportType.ENDURO_AUTO_RACING]: new SportTypeFieldsVisibility(true, true, true,  true, true, true, true, true, true),
  [SportType.ENDURO_CROSS_COUNTRY]: new SportTypeFieldsVisibility(true, true, true,  true, true, true, true, true, true),
  [SportType.FITNESS]: new SportTypeFieldsVisibility(true, true, true,  true, false, false, false, false, false),
  [SportType.FOOTBALL]: new SportTypeFieldsVisibility(true, false, false,  true, false, false, false, false, false),
  [SportType.HANDBALL]: new SportTypeFieldsVisibility(true, false, false,  true, false, false, false, false, false),
  [SportType.HIKING]: new SportTypeFieldsVisibility(true, true, true,  true, true, true, true, true, true),
  [SportType.KAYAK]: new SportTypeFieldsVisibility(true, true, true,  true, true, true, true, true, true),
  [SportType.MOTOCROSS]: new SportTypeFieldsVisibility(true, true, true,  true, true, true, true, true, true),
  [SportType.MULTISPORT]: new SportTypeFieldsVisibility(true, false, false,  false, false, false, false, false, false),
  [SportType.NORDIC_WALKING]: new SportTypeFieldsVisibility(true, true, true,  true, true, true, true, true, true),
  [SportType.ORIENTEERING]: new SportTypeFieldsVisibility(true, true, true,  true, true, true, true, true, true),
  [SportType.OTHER]: new SportTypeFieldsVisibility(true, true, true,  true, true, true, true, true, true),
  [SportType.PADDLING]: new SportTypeFieldsVisibility(true, true, true,  true, true, 0, 0, 0, 0),
  [SportType.ROAD_RUNNING]: new SportTypeFieldsVisibility(true, true, true,  true, true, true, true, true, true),
  [SportType.ROLLER_SKATING]: new SportTypeFieldsVisibility(true, true, true,  true, true, true, true, true, true),
  [SportType.ROWING]: new SportTypeFieldsVisibility(true, true, true,  true, true, 0, 0, 0, 0),
  [SportType.SKIING]: new SportTypeFieldsVisibility(true, true, true,  true, true, true, true, true, true),
  [SportType.SUP]: new SportTypeFieldsVisibility(true, true, true,  true, true, 0, 0, 0, 0),
  [SportType.SWIMMING]: new SportTypeFieldsVisibility(true, true, true,  true, true, 0, 0, 0, 0),
  [SportType.TRAIL_RUNNING]: new SportTypeFieldsVisibility(true, true, true,  true, true, true, true, true, true),
  [SportType.TRIATHLON]: new SportTypeFieldsVisibility(true, true, true,  true, true, true, true, true, true),
  [SportType.VELODROME]: new SportTypeFieldsVisibility(true, true, true,  true, true, true, true, true, true),
  [SportType.VOLLEYBALL]: new SportTypeFieldsVisibility(true, false, false,  true, false, false, false, false, false),
  [SportType.WALKING]: new SportTypeFieldsVisibility(true, true, true,  true, true, true, true, true, true),
  [SportType.WATER_POLO]: new SportTypeFieldsVisibility(true, false, false,  true, false, false, false, false, false),
  [SportType.HYBRID_RACE]: new SportTypeFieldsVisibility(true, true, true,  true, false, false, false, false, false),
};

